module.exports = __webpack_public_path__ + "img/school5.1e201ecf.jpg";